import { MessageCircle } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

export default function WhatsAppFloat() {
  const { content, waLink } = useLang();
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="WhatsApp"
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-3"
    >
      <span className="hidden rounded-full border border-brand-line bg-white px-4 py-2 text-[13px] font-semibold text-brand-navy opacity-0 shadow-lg transition-all duration-300 group-hover:opacity-100 sm:block">
        {content.header.clientArea ? content.hero.ctaWa : 'WhatsApp'}
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_16px_32px_-12px_rgba(37,211,102,0.65)] transition-transform duration-300 group-hover:scale-105">
        <span className="absolute inset-0 animate-sonar rounded-full bg-[#25D366]" />
        <MessageCircle className="relative h-7 w-7" />
      </span>
    </a>
  );
}